// client/loginFunctions.ts
import { BaseError } from "@adornis/validation/errors/BaseError.js";
import { AdornisUser } from "../db/a-user.js";
import { NotLoggedInError } from "../db/errors.js";
import { emailRegexCheck, nameRegexCheck } from "../db/validators.js";
import {
  _subscribeCurrentUser,
  currentUser,
  impersonatingUser,
  unsubscribeCurrentUser,
  updateCurrentUser
} from "./currentUser.js";
var login = async (usernameOrMail, password, loginTTL) => {
  if (!nameRegexCheck(usernameOrMail) && !emailRegexCheck(usernameOrMail))
    throw new BaseError("Error in login(): Provided usernameOrMail is no valid name nor email", {
      translationKey: "users.invalid_username"
    });
  if (!password)
    throw new BaseError("No password given", { translationKey: "users.no_password" });
  const [userID, userClass] = await AdornisUser.loginWithPassword(usernameOrMail, password)();
  updateCurrentUser(void 0, false);
  await _subscribeCurrentUser({ userID, userClass });
};
var logout = async () => {
  if (!await currentUser().result)
    throw new NotLoggedInError();
  unsubscribeCurrentUser();
  updateCurrentUser(null, true);
  impersonatingUser().next(null);
  await AdornisUser.downGradeSession()();
};
export {
  login,
  logout
};
